// extracted by mini-css-extract-plugin
module.exports = {"HeaderContainer":"_3hv1u2Fx","HeaderTransparent":"_3VIkUvbV","button":"_345w57OU","Header":"_33ZRubEz","headerBoxShadow":"_2hRpgorl","LogoBlock":"aEaMMjKd","navLinksContainer":"_1CdOvb-_","navLink":"_1sdElL-Z","activeNavLink":"QbSSVqmU","darkLogo":"_39LJT1xc","NavDropdown":"_19fm784b","NavHamburger":"_2-UwpHUg","seafoam":"_2hhl3VNF","NavBlock":"_3lave4lo"};
    if(module.hot) {
      // 1746735760564
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  